import React from 'react';

type SegmentedSwitchLabels = {
    true: string;
    false: string;
};

export interface SegmentedSwitchProps {
    value: boolean;
    onChange: (value: boolean) => void;
    labels: SegmentedSwitchLabels;
    className?: string;
}

export const SegmentedSwitch: React.FC<SegmentedSwitchProps> = ({
    value,
    onChange,
    labels,
    className
}) => {

    const baseClass = "inline-flex items-center rounded-full bg-white/70 backdrop-blur px-1 py-1 text-sm font-medium shadow-inner";
    const containerClass = className ? `${baseClass} ${className}` : baseClass;

    const handleClick = (nextValue: boolean) => {
        if (nextValue === value) {
            return;
        }

        onChange(nextValue);
    };

    const trueButtonClass = value
        ? 'px-4 py-1.5 rounded-full bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow-lg transition-all'
        : 'px-4 py-1.5 rounded-full text-slate-600 hover:text-orange-600 transition-colors';

    const falseButtonClass = !value
        ? 'px-4 py-1.5 rounded-full bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow-lg transition-all'
        : 'px-4 py-1.5 rounded-full text-slate-600 hover:text-orange-600 transition-colors';

    return (
        <div className={containerClass}>
            <button
                type="button"
                className={trueButtonClass}
                onClick={() => handleClick(true)}
            >
                {labels.true}
            </button>
            <button
                type="button"
                className={falseButtonClass}
                onClick={() => handleClick(false)}
            >
                {labels.false}
            </button>
        </div>
    );
};

export default SegmentedSwitch;

